const partyConfigs = {
  'CDU|Union': {
    max: '#373737',
    name: 'CDU',
  },
  'CSU': {
    max: '#373737',
    name: 'CSU',
  },
  'CDU - CSU': {
    max: '#373737',
    name: 'CDU/CSU',
  },
  'SPD': {
    max: '#DB4240',
    name: 'SPD'
  },
  'Die.Linke|DIE LINKE|Linke': {
    max: '#96276E',
    name: 'Linke'
  },
  'PDS': {
    max: '#96276E',
    name: 'PDS'
  },
  'Grüne|Grünen': {
    max: '#4BA345',
    text: '#1F8F17',
    name: 'Grüne'
  },
  AfD: {
    max: '#34A3D2',
    name: 'AfD'
  },
  'FDP|F.D.P': {
    max: '#F6BB00',
    text: '#D59300',
    name: 'FDP'
  },
};

const coalitionConfigs = {

  'NI': {
    max: '#999999',
    name: 'Fraktionslos',
    subline: ''
  },

  'PPE': {
    max: '#2B4B8E',
    name: 'PPE',
    subline: 'Christdemokraten'
  },
  'S': {
    max: '#DB4240',
    name: 'S',
    subline: 'Sozialdemokraten'
  },
  'L': {
    max: '#F6BB00',
    text: '#D59300',
    name: 'L',
    subline: 'Liberale'
  },
  'COM': {
    max: '#89143B',
    name: 'COM',
    subline: 'Kommunisten und Nahestende'
  },
  'ED': {
    max: '#547AC0',
    name: 'ED',
    subline: 'Konservative'
  },
  'DEP': {
    max: '#547AC0',
    name: 'DEP',
    subline: 'Gaullisten und Sonstige'
  },
  'CDI': {
    max: '#999999',
    name: 'CDI',
    subline: 'Verschiedene Ausrichtungen'
  },

  'RDE': {
    max: '#547AC0',
    name: 'DEP',
    subline: 'Gaullisten und Sonstige'
  },
  'ARC': {
    max: '#4BA345',
    text: '#1F8F17',
    name: 'ARC',
    subline: 'Grüne und Regionalisten'
  },
  'DR': {
    max: '#35A3D2',
    name: 'DR',
    subline: 'Europäische Rechte'
  },

  'LDR': {
    max: '#F6BB00',
    text: '#D59300',
    name: 'LDR',
    subline: 'Liberale'
  },
  'V': {
    max: '#4BA345',
    text: '#1F8F17',
    name: 'V',
    subline: 'Grüne und Regionalisten'
  },
  'GUE': {
    max: '#89143B',
    name: 'GUE',
    subline: 'Linke Parteien'
  },
  'CG': {
    max: '#89143B',
    name: 'CG',
    subline: 'Linke Parteien'
  },

  'PSE': {
    max: '#DB4240',
    name: 'PSE',
    subline: 'Sozialdemokraten'
  },
  'ELDR': {
    max: '#F6BB00',
    text: '#D59300',
    name: 'ELDR',
    subline: 'Liberale'
  },
  'FE': {
    max: '#547AC0',
    name: 'FE',
    subline: '"Berlusconi"-Fraktion"'
  },
  'ARE': {
    max: '#ff9900',
    name: 'ARE',
    subline: 'Regionalisten'
  },
  'EDN': {
    max: '#547AC0',
    name: 'EDN',
    subline: 'EU-Skeptiker'
  },

  'EVP-ED': {
    max: '#2B4B8E',
    name: 'EVP-ED',
    subline: 'Christdemokraten und Konservative'
  },
  'Verts/ALE': {
    max: '#4BA345',
    name: 'Verts/ALE',
    subline: 'Grüne und Regionalisten'
  },
  'GUE/NGL': {
    max: '#89143B',
    name: 'GUE/NGL',
    subline: 'Linke Parteien'
  },
  'UEN': {
    max: '#547AC0',
    name: 'UEN',
    subline: 'EU-Skeptiker, Nationalkonservative'
  },
  'TDI': {
    max: '#35A3D2',
    name: 'TDI',
    subline: 'Rechte Parteien'
  },
  'EDD': {
    max: '#547AC0',
    name: 'EDD',
    subline: 'EU-Skeptiker'
  },

  'IND/DEM': {
    max: '#34A3D2',
    name: 'IND/DEM',
    subline: 'EU-Skeptiker, Rechtspopulisten'
  },

  'EVP': {
    max: '#2B4B8E',
    name: 'EVP',
    subline: 'Christdemokraten und Konservative'
  },
  'S&D': {
    max: '#DB4240',
    name: 'S&D',
    subline: 'Sozialdemokraten'
  },
  'ALDE': {
    max: '#F6BB00',
    text: '#D59300',
    name: 'ALDE',
    subline: 'Liberale'
  },
  'ALDE&R': {
    max: '#F6BB00',
    text: '#D59300',
    name: 'ALDE&R',
    subline: 'Liberale'
  },
  'Grünen/EFA': {
    max: '#4BA345',
    name: 'Grüne/EFA',
    subline: 'Grüne und Regionalisten'
  },
  'EKR': {
    max: '#547AC0',
    name: 'EKR',
    subline: 'EU-Skeptiker, Nationalkonservative'
  },
  'EFD': {
    max: '#35A3D2',
    name: 'EFD',
    subline: 'EU-Skeptiker, Rechtspopulisten'
  },

  'Grüne/EFA': {
    max: '#4BA345',
    name: 'Grüne/EFA',
    subline: 'Grüne und Regionalisten'
  },
  'EFDD': {
    max: '#35A3D2',
    name: 'EFDD',
    subline: 'EU-Skeptiker, Rechtspopulisten'
  },
  'ENF': {
    max: '#35A3D2',
    name: 'EFN',
    subline: 'Rechtspopulisten'
  }
};

const defaultConfig = {
  max: '#999',
  text: '#999'
};

const allConfigs = Object.assign(partyConfigs, coalitionConfigs, { default: defaultConfig });

export const parties = Object.keys(allConfigs).reduce((all, key) => {
  key.split('|').forEach(k => all[k.toLowerCase()] = allConfigs[key]);
  return all;
}, {});

export const hasColor = (partyName = '') => {
  return !!parties[partyName.toLowerCase()];
};

export const getColor = (partyName = '') => {
  return hasColor(partyName) ? parties[partyName.toLowerCase()].max : parties.default.max;
};

export const getTextColor = (partyName = '') => {
  const partyItem = parties[partyName.toLowerCase()];
  const color = getColor(partyName);
  return (typeof partyItem !== 'undefined' && partyItem.text) ? partyItem.text : color;
};

export const getDefaultColor = () => {
  return parties.default.max;
};

const mapNoDataColor = '#ddd';

export const getMapColorColor = (partyName = '') => {
  return hasColor(partyName) ? parties[partyName.toLowerCase()].max : mapNoDataColor;
};

export const getNaColor = () => {
  return '#ddd';
}

export const getName = (partyName = '') => {
  return parties[partyName.toLowerCase()] ? parties[partyName.toLowerCase()].name : partyName;
};

export const getSubline = (partyName = '') => {
  return parties[partyName.toLowerCase()] ? parties[partyName.toLowerCase()].subline : partyName;
};

export const descriptions = {
  1979: 'Am 7. und 10. Juni 1979 können die Bürger der damals neun EU-Mitgliedsstaaten erstmals das Europäische Parlament wählen. Zuvor wurde es durch Vertreter der nationalen Parlamente bestimmt. Die Sozialdemokraten werden stärkste Kraft, vor den Christdemokraten. In Deutschland findet die Anti-Atomkraft-Bewegung nach einem Störfall im Atomkraftwerk Harrisburg (USA) immer mehr Anhänger - und zeigt sich mit Massendemonstrationen in Gorleben und später in Bonn.',
  1984: 'Das Europaparlament bekommt eine neue Farbe: Grün. Erstmals tritt die gleichnamige Bewegung als Partei in Deutschland an. Die 1980 gegründeten Grünen profitieren vom öko- und friedensbewegten Zeitgeist, aber indirekt auch vom Flick-Skandal. Die verdeckten Millionen-Spenden des Flick-Konzerns betreffen alle etablierten Parteien. Sie verlieren deutlich an Vertrauen - die FDP sogar alle Sitze im Europaparlament. In Frankreich und Italien feiern Rechtsextreme große Erfolge.',
  1989: 'Im Jahr 1989 findet der kalte Krieg sein Ende. In Polen geben die Kommunisten ihre Macht ab, Ungarn baut die Grenzanlagen zu Österreich ab, und auch in der DDR wächst der Protest - der Monate später zum Mauerfall beiträgt. Bei der Europawahl wird aber zunächst die Süderweiterung deutlich: Spanien und Portugal nehmen erstmals teil. Im noch geteilten Deutschland erleidet Helmut Kohls Union starke Verluste. Und die rechten Republikaner überraschen mit ihrem Einzug.',
  1994: 'Vier Jahre nach der Wiedervereinigung wählen erstmals auch die Ostdeutschen mit. Doch auch Europa ist mittlerweile enger zusammengerückt: Durch den Vertrag von Maastricht (1992) ist aus der EWG die EU geworden, die deutlich mehr sein soll als ein Binnenmarkt. So ist nun jeder Staatsbürger eines EU-Landes auch Unionsbürger: Er kann sich innerhalb der EU frei bewegen - und an seinem Wohnort an Kommunal- und Europawahlen teilnehmen, unabhängig von seiner Staatsangehörigkeit.',
  1999: 'Europa hat seit dem 1. Januar eine gemeinsame Währung: Der Euro wird in elf EU-Staaten Zahlungsmittel für den bargeldlosen Geldverkehr - drei Jahre später auch das offizielle Bargeld. Und das Europäische Parlament wird größer: Erstmals nehmen Österreich, Finnland und Schweden teil. Für Europas Sozialdemokraten endet eine Ära der Siege - zugunsten der Christdemokraten. Die SED-Nachfolgepartei PDS kommt durch starken Zuspruch im Osten ins Europaparlament.',
  2004: 'Am 1. Mai wächst die EU schlagartig von 15 auf 25 Staaten - um Estland, Lettland, Litauen, Malta, Polen, Slowakei, Slowenien, Tschechien, Ungarn und Zypern. 15 Jahre nach dem Fall des Eisernen Vorhangs wird nun auch im Osten des Kontinents das Europaparlament gewählt. Die Agenda 2010 - der Reformkurs der rot-grünen Bundesregierung - sorgt für Massenproteste in Deutschland. Die SPD erleidet herbe Wahlverluste (-9,2 Prozentpunkte). Und die FDP ist wieder dabei.',
  2009: 'Die Europawahl fällt 2009 in den Vorwahlkampf zur Bundestagswahl - sie gilt in Deutschland als Test für die Abstimmung im September. Die erste große Koalition unter Angela Merkel (CDU) versucht mit Abwrackprämien und Bad Banks die Folgen der Finanzkrise abzufedern, gilt aber als angekratzt. Es herrscht Wechselstimmung. Bei der Europawahl verlieren beide. Die FDP profitiert am stärksten von der Schwäche der Volksparteien.',
  2014: 'Es ist die erste Europawahl seit Ausbruch und Höhepunkt der Euro-Krise. Die Rettungspakete für Griechenland haben für eine stärkere EU-Skepsis gesorgt und neuen Kräften Auftrieb gegeben: Die AfD schafft es mit sieben Abgeordneten ins EU-Parlament. Die Partei driftet immer weiter nach rechts - und drängt ihren Gründer Bernd Lucke (Foto) raus. Am Ende der Wahlperiode ist nur noch ein Abgeordneter AfD-Mitglied: Jörg Meuthen.',
  2019: 'Bei der Europawahl haben die großen Volksparteien verloren - und Rechte konnten in vielen EU-Staaten triumphieren. Die AfD hat aber insgesamt schwächer abgeschnitten als erwartet - auch wenn die Rechtspopulisten in vielen Kreisen im Osten stärkste Kraft geworden sind. Großer Gewinner sind in Deutschland die Grünen, sie liegen erstmals vor den Sozialdemokraten. Auch in vielen Ländern Europas bekommen grüne Kräfte Auftrieb.'
};

export const headlines = {
  1979: '1979 - Immer mehr sagen "Atomkraft? Nein danke"',
  1984: '1984 - Grüne ziehen erstmals ins Europaparlament',
  1989: '1989 - Eiserner Vorhang fällt, Rechte überraschen',
  1994: '1994 - EU-Bürger können nun überall wählen',
  1999: '1999 - Der Euro ist da, aber noch nicht in bar',
  2004: '2004 - EU wächst von 15 auf 25 Mitgliedsstaaten',
  2009: '2009 - EU-Wahl als Stimmungstest nach der Finanzkrise',
  2014: '2014 - AfD schafft erstmals Einzug in überregionales Parlament',
  2019: '2019 - Volksparteien verlieren, Grüne bekommen Auftrieb'
};

export const germanStates = {
  'sh': 'Schleswig-Holstein',
  'hh': 'Hamburg',
  'ni': 'Niedersachsen',
  'br': 'Bremen',
  'nrw': 'Nordrhein-Westfalen',
  'he': 'Hessen',
  'rp': 'Rheinland-Pfalz',
  'bw': 'Baden-Württemberg',
  'by': 'Bayern',
  'sl': 'Saarland',
  'ber': 'Berlin',
  'bb': 'Brandenburg',
  'mv': 'Mecklenburg-Vorpommern',
  'sa': 'Sachsen-Anhalt',
  'ss': 'Sachsen',
  'th': 'Thüringen',
  'de': 'Gesamt'
};

export const getStateName = (stateShort = '') => {
  return germanStates[stateShort.toLowerCase()] ? germanStates[stateShort.toLowerCase()] : stateShort;
};

export const years = ['1979','1984','1989','1994','1999','2004','2009','2014','2019'];